"use client";

import { useActiveGame } from "@/app/oyun/_hooks/useActiveGame";
import { useRouter } from "@/i18n/navigation";
import { useState } from "react";

export function useNavbarPlay(isAuthenticated: boolean) {
    const router = useRouter();
    const activeGameRoomCode = useActiveGame();
    const [isCreateGameDialogOpen, setIsCreateGameDialogOpen] = useState(false);

    const startPlaying = () => {
        if (activeGameRoomCode) {
            router.push(`/oyun/${activeGameRoomCode}`);
            return;
        }

        if (!isAuthenticated) {
            router.push("/login");
            return;
        }

        setIsCreateGameDialogOpen(true);
    };

    return {
        isCreateGameDialogOpen,
        setIsCreateGameDialogOpen,
        startPlaying,
    };
}
